export default __webpack_public_path__ + "static/media/icon-motor.c9f3d1cd.svg";